var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "drawer-wrapper"
  }, [_c('CustomerSearchSidebar'), _c('div', {
    staticClass: "customer-detail-wrap"
  }, [_c('h1', {
    staticClass: "customer-title"
  }, [_vm._v(_vm._s(_vm.customer.name))]), _c('div', {
    staticClass: "customer-detail"
  }, [_c('CustomerInfo')], 1)]), _c('Comment', {
    staticClass: "comment"
  }), _c('router-view', {
    staticClass: "content"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }